import React, { Component } from "react";

class GolfStatusBadge extends Component {

    render() {
        let span = "";
        let now = new Date(this.props.curTime);
        for (var i = 0; i < this.props.slots.length; i++) {
            let start_slot = new Date(now.getFullYear(), now.getMonth(), now.getDate(), this.props.slots[i].sh, this.props.slots[i].sm);
            let end_slot = new Date(now.getFullYear(), now.getMonth(), now.getDate(), this.props.slots[i].eh, this.props.slots[i].em);

            if (now.getTime() > start_slot.getTime() && now.getTime() < end_slot.getTime()) {
                if (this.props.slots[i].tp === 0) {
                    span = (<span className='badge badge-success'>Active</span>);
                    break;
                }
                else
                    span = (<span className='badge badge-warning'>TMZ Only</span>)
                break;
            }
            else
                span = (<span className='badge badge-secondary ml-2'>Not Active</span>)

        }
        return span;
    }
}

export default GolfStatusBadge;
